<script>
    import {fade} from 'svelte/transition';
    export let text;
    export let type;
    console.log(type)
</script>

<div transition:fade class="toast br2">
    <div class="bar {type}"></div>
    <p class="message">{text}</p>
</div>

<style>
    .success {
        background-color: #17C3B2 !important;
    }
    .error {
        background-color: #F25F5C !important;
    }
    .toast {
        color: #ECE6EF;
        background-color: #25262D;
        height: 2rem;
        width: fit-content;
        padding-right: 1rem;
        display: flex;
        align-items: center;
        margin-top: 0.2rem;
        -webkit-box-shadow: 0px 2px 15px -1px #000000; 
        box-shadow: 0px 2px 15px -1px #000000;
        overflow: hidden;
    }

    .message {
        padding-top: 0px;
        padding-bottom: 3px;
    }
    .bar {
        background-color: white;
        height: 100%;
        width: 4px;
        margin-right: 1rem;
    }
    .bar success {
        background-color: #17C3B2 !important;
    }

</style>
